import { createOperationDescriptor, getRequest, type IEnvironment } from 'relay-runtime';

import {
	MultiMacroQueryWithAppKeyQuery,
	type multiMacroQueryWithAppKeyQuery$data,
	type multiMacroQueryWithAppKeyQuery$variables,
} from '@confluence/fabric-extension-queries/entry-points/multiMacroQueryWithAppKeyQuery.ts';
import { getEffectiveMultiMacroQueryBlocklist } from '@confluence/fabric-extension-queries/entry-points/useMultiMacroQuery.ts';

const NIL_UUID = '00000000-0000-0000-0000-000000000000';

// Must match `DEFAULT_PRELOAD_COUNT` in `preloadMacrosSSRMultiple`, or the lookup misses the preloaded record.
const SSR_PRELOAD_COUNT = 8;

export type PreloadedStaticMacro = {
	value?: string | null;
	errorCode?: string | null;
};

/**
 * Synchronously reads the static macros cached in the Relay store by the SSR preload
 * (`preloadMacrosSSRMultiple`), keyed by macro local ID. Returns an empty map when there is no
 * complete preloaded record.
 */
export function readPreloadedStaticMacros(
	environment: IEnvironment | undefined,
	contentId: string,
	cloudId: string | undefined,
): Map<string, PreloadedStaticMacro> {
	const macros = new Map<string, PreloadedStaticMacro>();
	if (!environment || !contentId) {
		return macros;
	}

	const variables: multiMacroQueryWithAppKeyQuery$variables = {
		first: SSR_PRELOAD_COUNT,
		staticFirst: SSR_PRELOAD_COUNT,
		contentId,
		cloudId: cloudId || NIL_UUID,
		blocklist: getEffectiveMultiMacroQueryBlocklist(),
	};
	const operation = createOperationDescriptor(
		getRequest(MultiMacroQueryWithAppKeyQuery),
		variables,
	);
	const snapshot = environment.lookup(operation.fragment);
	if (snapshot.isMissingData) {
		return macros;
	}

	const data = snapshot.data as multiMacroQueryWithAppKeyQuery$data | null;
	for (const node of data?.staticMacros?.nodes ?? []) {
		if (node?.macroId) {
			macros.set(node.macroId, { value: node.value, errorCode: node.error?.code });
		}
	}

	return macros;
}
